<template>
  <div>
    <base-header v-once pageName="일정관리" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap" class="schedule">
      <ul class="tab tab-fix">
        <li><button type="button" class="current">내 일정</button></li>
        <li>
          <button type="button" @click="goHd()">
            본사 일정
          </button>
        </li>
      </ul>

      <div class="calendar" v-if="'M' == calendarInfo.wOrM">
        <p>
          <button type="button" class="prev" @click="goPreMonCalendar">이전</button>
          <strong>{{calendarInfo.y}}년 {{calendarInfo.intM}}월</strong>
          <button type="button" class="next" @click="goNextMonCalendar">다음</button>
        </p>
        <ul class="week">
          <li>일</li>
          <li>월</li>
          <li>화</li>
          <li>수</li>
          <li>목</li>
          <li>금</li>
          <li>토</li>
        </ul>
        <ul>
          <li v-for="(value, index) in arrayMonthDate" v-bind:key="index" :class="{ this: checkThisMon(value), on: onMeeting(value), late: lateMeeting(value), current:calendarInfo.searchDay == value, today:calendarInfo.today == value}"  @click="getMyscheduleList(value)" >
            {{ getOnlyDate(value) }}
            <span v-if="getScheduleCount(value) > 0"><i v-for="(value, index) in getScheduleCount(value)" v-bind:key="index"></i></span>
          </li>
        </ul>
        <button type="button" class="key down" @click="changeCalendarType"></button>
      </div>
      <div class="calendar" v-if="'W' == calendarInfo.wOrM">
        <p>
          <button type="button" class="prev" @click="goOtherWeekCalendar('PRE')">이전</button>
          <strong>{{calendarInfo.y}}년 {{calendarInfo.intM}}월 ({{calendarInfo.selectedWeekNum}}/ {{calendarInfo.totalWeekNum}}) </strong>
          <button type="button" class="next" @click="goOtherWeekCalendar('NEXT')">다음</button>
        </p>
        <ul class="week">
          <li>일</li>
          <li>월</li>
          <li>화</li>
          <li>수</li>
          <li>목</li>
          <li>금</li>
          <li>토</li>
        </ul>
        <ul>
          <li v-for="(value, index) in arrayWeekDate" v-bind:key="index" :class="{ this: checkThisMon(value), on: onMeeting(value), late: lateMeeting(value), current:calendarInfo.searchDay == value, today:calendarInfo.today == value}"  @click="getMyscheduleList(value)" >
            {{ getOnlyDate(value) }}
            <span v-if="getScheduleCount(value) > 0"><i v-for="(value, index) in getScheduleCount(value)" v-bind:key="index"></i></span>
          </li>
        </ul>
        <button type="button" class="key" @click="changeCalendarType"></button>
      </div>
      <div class="ep-schedule">
        <div class="legend">
          <h4 class="today">{{ searchDayForView }} </h4>
          <div>
            <span class="on">인정</span>
            <span class="late">지각/입장</span>
          </div>
        </div>
        <div class="meeting-info" v-if="myMeeting.attendStatus !== 'X'">
          <span>아침미팅참석 등록시간</span>
          <span>{{ myMeeting.akdtim }}</span>
        </div>
        <div class="meeting-info" v-if="myMeeting.attendStatus === 'Y'">
            <span>퇴장 등록시간</span>
            <span>{{ myMeeting.levtim }}</span>
        </div>
        <ul>
          <li v-if="(schedule.myScheduleList && schedule.myScheduleList.length || 0)
                  + (schedule.homeclassList && schedule.homeclassList.length || 0) === 0"
              class="dataNone">
            등록된 일정이 없습니다.
          </li>
          <!-- 홈클래스 일정 추가 v-if="orgnzPstn != 'COG01'"-->
          <template v-if="orgnzPstn !== 'COG01'">
          <li  v-for="(homeclass,index) in schedule.homeclassList" v-bind:key="index" v >
            <em class="my">방문</em>
            <div class="homeclass-items">
              <span>{{ homeclass.sbjcNm}}</span>
              <p >
                <i>{{homeclass.vstHr }}</i> {{homeclass.memberNm }} 회원
              </p>
            </div>
          </li>
          </template>
          <template v-if="orgnzPstn === 'COG01'">
          <li  v-for="(homeclass,index) in schedule.groupedHomeclassList" v-bind:key="index" v >
              <em class="my">방문</em>
              <div class="homeclass-items">
              <strong>{{ homeclass.userNm }}</strong>
              <p v-for="(hc, idx) in homeclass.list" :key="idx">
                {{ hc.sbjcNm }}
                <i>{{ hc.vstHr }}</i>
                {{ hc.memberNm }} 회원
              </p>
            </div>
          </li>
          </template>
          <li v-for="(mySchedule,index) in schedule.myScheduleList" v-bind:key="index" @click="popView(index)">
            <em class="my">{{ mySchedule.scdlDivNm }}</em>
            <div>
              <span v-if="mySchedule.allYn =='Y'">하루종일</span>
              <span v-if="mySchedule.allYn =='N'">{{ getScheduleHr(mySchedule) }}</span>
              <p v-if="['SSD03', 'SSD07'].includes(mySchedule.scdlDivCd)">
                {{ mySchedule.etcCntn }}
              </p>
              <p v-else>
                <i>{{ mySchedule.custNm }}</i>님
              </p>
              <button @click.stop="updateCmplYn(index)" type="button" class= "chk " :class="{ complete: 'Y' == mySchedule.cmplYn ? true : false}" ></button>
            </div>
          </li>
        </ul>

        <div class="list" v-if="schedule.concExpDueList.length > 0" >
          <h6>계약만료 예정 안내</h6>

          <swiper class="swiper scheduleSwiper" :options="contractSwiper">
              <swiper-slide v-for="(concExpDue,index) in schedule.concExpDueList" v-bind:key="index">
                <strong><i>{{ concExpDue.custNm }}</i>님</strong>
                <span>{{ getFormattedDate(concExpDue.concexpydy, '.') }}</span>
                <button  @click.stop="cmplConcExpDueSchedule(index)" type="button" class="chk"></button>
              </swiper-slide>
          </swiper>
        </div>

        <div class="list" v-if="schedule.reinspecList.length > 0" >
          <h6>진단 재검사 시점 안내</h6>

          <swiper class="swiper scheduleSwiper" :options="diagSwiper">
            <swiper-slide v-for="(reinspec,index) in schedule.reinspecList" v-bind:key="index">
              <strong><i>{{ reinspec.cnm }}</i>님</strong>
              <span>{{ reinspec.compDt }}</span>
              <button @click.stop="cmplReinspecSchedule(index)" type="button" class="chk"></button>
            </swiper-slide>
          </swiper>
        </div>

        <div class="list" v-if="schedule.bookcareList.length > 0">
          <h6>북케어 일정 안내</h6>

          <swiper class="swiper scheduleSwiper" :options="bookSwiper">
            <swiper-slide v-for="(bookcare,index) in schedule.bookcareList" v-bind:key="index">
              <strong><i>{{ bookcare.rppnam }}</i>님</strong>
              <span>{{ bookcare.rpndte }}</span>
              <button @click.stop="cmplBookcareSchedule(index)" type="button" class="chk"></button>
            </swiper-slide>
          </swiper>
        </div>

        <div class="birthday" v-if="schedule.birthdayList.length > 0">
          <h6>오늘의 생일자</h6>
          <div>
            <span v-for="(birthday,index) in schedule.birthdayList" v-bind:key="index"><i>{{ birthday.custNm }}</i>님</span>
          </div>
        </div>

        <!--div class="edu">
          <h6>사이버연수원 교육 마감 안내</h6>
        </div-->

        <button type="button" class="register" @click="goReg()">
          일정등록
        </button>
      </div>
      <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
      <!--// 2026.09.18 챗봇 버튼-->
    </section>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "MyScheduleList",
  data() {
    return {
      orgnzPstn: this.$store.getters.orgnzPstn,
      contractSwiper: {
          slidesPerGroup : 2,
          slidesPerView : 'auto',
          spaceBetween : 10,
      },
      diagSwiper: {
          slidesPerGroup : 2,
          slidesPerView : 'auto',
          spaceBetween : 10,
      },
      bookSwiper: {
          slidesPerGroup : 2,
          slidesPerView : 'auto',
          spaceBetween : 10,
      },
      calendarInfo:{
        y: "",
        m: "",
        intM: 0,
        today: "",
        searchDay: "",
        wOrM: "M",
        selectedWeekNum: 0,
        totalWeekNum: 0
      },
      arrayMonthDate:[
      ],
      arrayWeekDate:[
      ],
      searchDayForView: "",
      params: {
        searchYear: "",
        searchMon: "",
        searchDay: ""
      },
      myScheduleCountList: [
        {
          monthDate: "",
          cnt: 0
        }
      ],
      myHomeclassCountList: [
        {
          monthDate: "",
          cnt: 0
        }
      ],
      myMeetingList: [
        {
          attendDate: "",
          attendStatus: ""
        }
      ],
      schedule: {
        myScheduleList: [
        ],
        concExpDueList: [
        ],
        reinspecList: [
        ],
        birthdayList: [
        ],
        bookcareList: [
        ],
        homeclassList: [
        ],
        groupedHomeclassList: {
        },
      },
      selectedSqno: 0,
      myMeeting: {
          attendStatus: 'X'
      },
      loginGbn : this.$store.getters.loginGbn, //로그인구분
    };
  },
	watch: { // 팝업창에서 선택된 값 받는 부분.
		'$store.state.ui.child'(child) {
			if(child.name == 'go-to-modi'){  // 상세화면에서 수정을 누른 경우
        this.$router.push('/mySchedule/myScheduleReg/' + this.selectedSqno);
			}
      if(child.name == 'reload-myschedule'){  // 상세화면에서 일정 삭제한 후 재조회.
        this.$router.go(this.$router.currentRoute);
			}
    }
  },
  methods: {
    getFormattedDate(dd,Type){ // 날짜(dd)를 구분자(Type)로 구별해서 보여준다.
        if(dd){
            return dd.substr(0,4) + Type + dd.substr(4,2) + Type + dd.substr(6,2);
        }
    },
    getMyScheduleCountList(searchMon, callback) { // 해당 월의 각 날짜별 일정 카운트 조회
      var that = this;

      that.params.searchMon = searchMon;

      //console.log( "MyScheduleList.vue getMyScheduleCountList that.params", that.params );

      this.$api.myschedule.getMyScheduleCountList(that.params)
        .then(function(res) {
          //console.log( "MyScheduleList.vue <api.myschedule.getMyScheduleCountList.response>", res.myScheduleCountList  );
          //console.log( "MyScheduleList.vue <api.myschedule.getMyscheduleList.response> myMeetingList",  res.myMeetingList );
          //console.log( "MyScheduleList.vue <api.myschedule.getMyScheduleCountList.response> length", res.myScheduleCountList.length );
          that.myScheduleCountList = res.myScheduleCountList;
          that.myMeetingList = res.myMeetingList;
          that.myHomeclassCountList = res.myHomeclassCountList;
          //console.log( "MyScheduleList.vue <api.myschedule.getMyScheduleCountList.response>", that.myHomeclassCountList  );
          if (callback) {
              callback(that.calendarInfo.today);
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getMyscheduleList(searchDay) { // 해당 일의 일정 목록조회
      //console.log("MyScheduleList.vue getMyscheduleList searchDay", searchDay);
      var that = this;

      this.calendarInfo.searchDay = searchDay;

      var searchYear = searchDay.substr(0,4);
      var searchDayFormatted = this.getFormattedDate(searchDay, '.'); //날짜 형식
      var thisDatOfWeek = this.getDayOfWeek(searchDay.substr(0,4),searchDay.substr(4,2) * 1,searchDay.substr(6,2)); // 요일
      var searchDayForView = searchDayFormatted + ' (' +  thisDatOfWeek + ')';

      //console.log("thisDatOfWeek:" + thisDatOfWeek);
      //console.log("searchDayForView:" + searchDayForView);

      this.searchDayForView = searchDayForView; // 달력 하단 선택된 날짜 표시용.

      that.params.searchYear = searchYear;
      that.params.searchDay  = searchDay;

      //console.log("MyScheduleList.vue getMyscheduleList that.params", that.params);

      this.$api.myschedule.getMyscheduleList(that.params)
        .then(function(res) {
          //console.log( "MyScheduleList.vue <api.myschedule.getMyscheduleList.response> myScheduleList",  res.myScheduleList );
          //console.log( "MyScheduleList.vue <api.myschedule.getMyscheduleList.response> reinspecList",  res.reinspecList );
          //console.log( "MyScheduleList.vue <api.myschedule.getMyscheduleList.response> bookcareList",  res.bookcareList );
          that.schedule = res;
                    console.log("MyScheduleList.vue groupedHomeclassList", res);
          console.log("MyScheduleList.vue groupedHomeclassList", that.schedule);

          if (that.orgnzPstn === 'COG01' && res.homeclassList) {
            const grouped = {};
            res.homeclassList.forEach(hc => {
              const key = hc.userNm; // 선생님명 기준

              if (!grouped[key]) {
                grouped[key] = {
                  userNm: key,
                  list: []
                };
              }

              grouped[key].list.push(hc);
            });
            // schedule에 지국장 전용 데이터 추가
            that.schedule.groupedHomeclassList = grouped;
          } else {
            // 지국장이 아니면 빈 객체
            that.schedule.groupedHomeclassList = {};
          }
           const meeting = _(that.myMeetingList)
            .filter(v => {
              return v.attendDate === that.params.searchDay;
            })
            .head();
          if (meeting) {
              that.myMeeting = meeting;
          } else {
              that.myMeeting = {
                  attendStatus: 'X'
              }
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    popView: function (index){ // 상세보기 화면으로
      //this.$router.push('/mySchedule/myScheduleView/' + this.schedule.myScheduleList[index].sqno);
      this.selectedSqno = this.schedule.myScheduleList[index].sqno;
      this.$utils.nativeIf.outbound.newPage('/mySchedule/myScheduleView/' + this.schedule.myScheduleList[index].sqno);
    },
    updateCmplYn: function (index){ // 일정 완료/미완료 처리
    var that = this;
        //console.log(index);

        if("N" == this.schedule.myScheduleList[index].cmplYn){
          this.schedule.myScheduleList[index].cmplYn = "Y";
        }else{
          this.schedule.myScheduleList[index].cmplYn = "N";
        }

      var params = {cudType:"CMP",sqno:this.schedule.myScheduleList[index].sqno,cmplYn:this.schedule.myScheduleList[index].cmplYn};
      //console.log("MyScheduleList.vue updateCmplYn params", params);

      this.$api.myschedule.saveMyschedule(params)
        .then(function() {
          if("Y" == that.schedule.myScheduleList[index].cmplYn){
            alert("일정완료 상태로 변경하였습니다");
          }else{
            alert("일정 미완료 상태로 변경하였습니다");
          }

        })
        .catch(function(error) {
          alert(error.rtMsg);
          if("Y" == that.schedule.myScheduleList[index].cmplYn){
            that.schedule.myScheduleList[index].cmplYn = "N";
          }else{
            that.schedule.myScheduleList[index].cmplYn = "Y";
          }
        });
    },
    cmplConcExpDueSchedule: function (index){ // 계약만료예정 안내 완료처리
      //console.log(index);
      var that = this;

      // Dimmed layer 팝업?
      if(!confirm("선택하신 일정을 완료처리 하시겠습니까? \n완료 시 항목에서 삭제가 됩니다.")){
        return;
      }else{
        var params = {kwkey:this.schedule.concExpDueList[index].kwkey
                      ,concexpydy:this.schedule.concExpDueList[index].concexpydy};
        console.log("MyScheduleList.vue cmplConcExpDueSchedule params", params);

        this.$api.myschedule.cmplConcExpDueSchedule(params)
          .then(function() {
            that.schedule.concExpDueList.splice(index,1); // 화면 목록에서 삭제처리.
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
      }
    },
    cmplReinspecSchedule: function (index){ // 진단재검사 안내 완료처리
      //console.log(index);
      var that = this;

      // Dimmed layer 팝업?
      if(!confirm("선택하신 일정을 완료처리 하시겠습니까? \n완료 시 항목에서 삭제가 됩니다.")){
        return;
      }else{
        var params = {couponNo:this.schedule.reinspecList[index].couponNo};
        //console.log("MyScheduleList.vue cmplReinspecSchedule params", params);

        this.$api.myschedule.cmplReinspecSchedule(params)
          .then(function() {
            that.schedule.reinspecList.splice(index,1); // 화면 목록에서 삭제처리.
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
      }
    },
    cmplBookcareSchedule: function (index){ // 북케어 안내 완료처리
      //console.log(index);
      var that = this;

      // Dimmed layer 팝업?
      if(!confirm("선택하신 일정을 완료처리 하시겠습니까? \n완료 시 항목에서 삭제가 됩니다.")){
        return;
      }else{
        var params = {rpyery:this.schedule.bookcareList[index].rpyery
                      ,rpseqi:this.schedule.bookcareList[index].rpseqi
                      ,rpseri:this.schedule.bookcareList[index].rpseri};
        //console.log("MyScheduleList.vue cmplBookcareSchedule params", params);

        this.$api.myschedule.cmplBookcareSchedule(params)
          .then(function() {
            that.schedule.bookcareList.splice(index,1); // 화면 목록에서 삭제처리.
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
      }
    },
    goHd(){ // 본사일정 페이지로 연결
      this.$router.push('/mySchedule/hdSchedule');
    },
    goReg(){ // 등록페이지로 연결
      this.$router.push('/mySchedule/myScheduleReg').then((() =>window.scrollTo(0,0) )); // 이동후 맨 위로 이동.
      //this.$utils.nativeIf.outbound.newPage('/mySchedule/myScheduleReg');
    },
    getOnlyDate: function(d) { // 날짜만 리턴하기
      //console.log("MyScheduleList.vue getOnlyDate d", d);
      return d.substr(6,2) * 1;
    },
    checkThisMon: function(d) { // 조회한 달과 같은 달인지 체크.
      //console.log("MyScheduleList.vue checkThisMon d", d);
      if(this.calendarInfo.y + this.calendarInfo.m == d.substr(0,6)){
        return true;
      }
      return false;
    },
    onMeeting: function(d) { // 출석했는지 체크.
      //console.log("MyScheduleList.vue checkMeeting d", d);
      var val = false;
      this.myMeetingList.forEach(element => {
        if(element.attendDate == d){
          if("Y" == element.attendStatus){ // 정상 출근
            val = true;
          }
        }
      });
      return val;
    },
    lateMeeting: function(d) { // 출석했는지 체크.
      //console.log("MyScheduleList.vue checkMeeting d", d);
      var val = false;
      this.myMeetingList.forEach(element => {
        if(element.attendDate == d){
          if("N" == element.attendStatus){  // 지각
            val = true;
          }
          if("S" == element.attendStatus){ // 입장
            val = true;
          }
        }
      });
      return val;
    },
    getScheduleCount: function (d) {
      // d : 달력에서 선택된 날짜 (형식: 'YYYYMMDD')
      // 목적 : 해당 날짜의 전체 스케줄 개수(일반 일정 + 홈클래스)를 반환

      // 1. 일반 등록 일정(myScheduleCountList)에서 해당 날짜 데이터 찾기
      const schedule = this.myScheduleCountList.find(c => c.monthDate === d);

      // 2. 홈클래스 일정(myHomeclassCountList)에서 해당 날짜 데이터 찾기
      const homeclass = this.myHomeclassCountList.find(c => c.monthDate === d);

      // 3. 일반 일정 개수 추출 (해당 날짜 데이터가 없으면 0)
      const scheduleCnt = schedule ? schedule.cnt : 0;

      // 4. 홈클래스 일정 개수 추출 (해당 날짜 데이터가 없으면 0)
      const homeclassCnt = homeclass ? homeclass.cnt : 0;

      // 5. 두 개수를 합산하여 해당 날짜의 총 스케줄 개수 반환
      return scheduleCnt + homeclassCnt;
    },
    getDayOfWeek: function(y,m,d) { // 해당일의 요일.
      var week = ['일', '월', '화', '수', '목', '금', '토'];
      var dayOfWeek = week[new Date(y,m-1,d).getDay()];
      return dayOfWeek;
    },
    goPreMonCalendar: function() { // 이전 월 달력
			var firstDayOfPreMon = new Date(this.calendarInfo.y, this.calendarInfo.intM - 2, 1);
      console.log("MyScheduleList.vue goPreMonCalendar firstDayOfPreMon", firstDayOfPreMon);
      var yearOfPreMon = firstDayOfPreMon.getFullYear();
			var monthOfPreMon = firstDayOfPreMon.getMonth() + 1;
      var preMon = yearOfPreMon + this.$utils.stringUtil.pad(monthOfPreMon);

      this.calculateMonthDateArray(preMon);
    },
    goNextMonCalendar: function() { // 이후 월 달력
			var firstDayOfNextMon = new Date(this.calendarInfo.y, this.calendarInfo.intM, 1);
      //console.log("MyScheduleList.vue goNextMonCalendar firstDayOfNextMon", firstDayOfNextMon);

      var yearOfNextMon = firstDayOfNextMon.getFullYear();
			var monthOfNextMon = firstDayOfNextMon.getMonth() + 1;
      var nextMon = yearOfNextMon + this.$utils.stringUtil.pad(monthOfNextMon);

      this.calculateMonthDateArray(nextMon);
    },
    goOtherWeekCalendar: function(type) { // 이전/이후 주 달력 이동
			// console.log("goOtherWeekCalendar type:" + type);
			// console.log("goOtherWeekCalendar this.calendarInfo.selectedWeekNum:" + this.calendarInfo.selectedWeekNum);
      var postWeekNum = 0;
      if("PRE" == type){
        postWeekNum = this.calendarInfo.selectedWeekNum - 1;
      }else{
        postWeekNum = this.calendarInfo.selectedWeekNum + 1;
      }
			// console.log("goOtherWeekCalendar this.calendarInfo.totalWeekNum:" + this.calendarInfo.totalWeekNum);
			// console.log("goOtherWeekCalendar postWeekNum:" + postWeekNum);

      if(postWeekNum > 0 && postWeekNum <= this.calendarInfo.totalWeekNum){
        var weekStartDate = this.$utils.calendar.getWeekStartByWeekNum(this.calendarInfo.y, this.calendarInfo.intM, postWeekNum);// 넘긴 년도, 월, 주 차수의 첫날 조회.
        var arrayDate = this.$utils.calendar.getWeekDateArray(weekStartDate); // 넘긴 날짜(Date type)로 시작하는 7일 날짜 배열 조회.
        // console.log("arrayDate:" + arrayDate);
        // console.log("-------------------------------");

        this.calendarInfo.selectedWeekNum = postWeekNum;
        this.arrayWeekDate = arrayDate;
      }
    },
    changeCalendarType: function() { // 월 달력/ 주 달력 보이기 변경.
      var wOrM = this.calendarInfo.wOrM;
      if("W" == wOrM){
        this.calendarInfo.wOrM = "M";
      }else{
        this.calculateWeekDateArray();
        this.calendarInfo.wOrM = "W";
      }
    },
    calculateMonthDateArray : function (selectedMon, callback) { // 해당 월의 날짜 목록 조회 및 일정 카운트 조회
      var y = selectedMon.substr(0,4);
      var m = selectedMon.substr(4,2);

      var arrayDate = this.$utils.calendar.calculateMonthDateArray(selectedMon);

			// console.log("arrayDate:" + arrayDate);
			// console.log("-------------------------------");

      this.arrayMonthDate = arrayDate;
      this.calendarInfo.y = y;
      this.calendarInfo.m = m;
      this.calendarInfo.intM = m * 1;

      this.getMyScheduleCountList(selectedMon, callback); // 선택한 달의 각 날짜별 일정 카운트 조회
    },
    calculateWeekDateArray : function () { // 검색일이나 새로운 달의 첫날 기준 주 달력 일자목록 조회.
      var selectedDate = this.calendarInfo.searchDay;
      var m = selectedDate.substr(4,2);

      if(this.calendarInfo.m != m){ // 달 달력이 다른 달이면, 해당 달의 첫날이 속한 주를 보여준다.
        selectedDate = this.calendarInfo.y + this.calendarInfo.m + "01";
      }

      var selectedDateAsDateType = this.$utils.calendar.getDateByStringDate(selectedDate);

      var totalWeekNum    = this.$utils.calendar.getTotalWeekNum(selectedDateAsDateType); // 넘긴 날짜(Date type)가 속한 달의 주 카운트.
      var selectedWeekNum = this.$utils.calendar.getSelectedWeekNum(selectedDateAsDateType); // 넘긴 날짜(Date type)가 속한 주의 달에서의 차수.

      var weekStartDate = this.$utils.calendar.getWeekStart(selectedDate); // 넘긴 날짜(문자열)가 속한 주의 첫날 조회.
      var arrayDate = this.$utils.calendar.getWeekDateArray(weekStartDate); // 넘긴 날짜(Date type)로 시작하는 7일 날짜 배열 조회.

			// console.log("arrayDate:" + arrayDate);
			// console.log("-------------------------------");

      this.calendarInfo.totalWeekNum = totalWeekNum;
      this.calendarInfo.selectedWeekNum = selectedWeekNum;
      this.arrayWeekDate = arrayDate;
    },
    getScheduleHr(mySchedule){ // 같은날 시작시각 종료시각이 같을 때는 시작시각만 보여준다.
      if(mySchedule.sttDt == mySchedule.endDt && mySchedule.sttHr == mySchedule.endHr){
        return mySchedule.sttHr;
      }
      else{
        return mySchedule.sttHr + ' ~ ' + mySchedule.endHr;
      }
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후

    // 이번 달과 오늘.
    var today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth() + 1;
    var d = today.getDate();

    var thisMon = y + this.$utils.stringUtil.pad(m);
    var thisDay = y + this.$utils.stringUtil.pad(m) + this.$utils.stringUtil.pad(d);

    //console.log("searchMon:" + thisMon);
    //console.log("searchDay:" + thisDay);

    this.calendarInfo.today = thisDay;

    this.calculateMonthDateArray(thisMon, this.getMyscheduleList);

    // this.getMyScheduleCountList(thisMon); // 이달의 각 날짜별 일정 카운트 조회
    //this.getMyscheduleList(thisDay); // 오늘의 일정 목록조회
  }
};
</script>
